import { render, staticRenderFns } from "./PageProfile.vue?vue&type=template&id=439000a6"
import script from "./PageProfile.vue?vue&type=script&lang=ts"
export * from "./PageProfile.vue?vue&type=script&lang=ts"
import style0 from "./PageProfile.vue?vue&type=style&index=0&id=439000a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports